import { UiColors } from "../../../../config/ui/colors";

export const INVESTMENT_RD_VS_GDP_CHART_DATA_KEYS = [
	{
		name: "percentage",
		color: UiColors.charts.primary,
	},
];